import Vue from 'vue';

const millimeterPerInch = 25.4;
const centimeterPerInch = 2.54;
const meterPerFoot = .3048;

const NPSToDN = {
    '1/8': 6,
    '1/4': 8,
    '3/8': 10,
    '1/2': 15,
    '3/4': 20,
    '1': 25,
    '1 1/4': 32,
    '1 1/2': 40,
    '2': 50,
    '2 1/2': 65,
    '3': 80,
    '3 1/2': 90,
    '4': 100,
    '5': 125,
    '6': 150,
    '8': 200,
    '10': 250,
    '12': 300,
};

const kilogramPerPound = .453592;
const kgKnConversion = .00980665;

const npsOrDn = function(nps, appVersion = null) {
    if (nps in NPSToDN) {
        return this.useMetric(appVersion) ? NPSToDN[nps] : nps;
    } else {
        return `not found (${nps})`;
    }
};

const inOrMm = function(inch, includeUnits, appVersion = null) {
    let v = this.useMetric(appVersion) ? (millimeterPerInch * inch).toFixed(2) : inch;
    return includeUnits ? `${v} ${this.useMetric(appVersion) ? 'mm.' : 'in.'}` : v;
};

const inOrCm = function(inch, includeUnits, appVersion = null) {
    let v = this.useMetric(appVersion) ? (centimeterPerInch * inch).toFixed(2) : inch;
    return includeUnits ? `${v} ${this.useMetric(appVersion) ? 'cm.' : 'in.'}` : v;
};

const ftOrM = function(foot, includeUnits, appVersion = null) {
    let v = this.useMetric(appVersion) ? (meterPerFoot * foot).toFixed(2) : foot;
    return includeUnits ? `${v} ${this.useMetric(appVersion) ? 'm.' : 'ft.'}` : v;
};

const lbOrKg = function(pound, includeUnits, floorIfMetric = false, appVersion = null) {
    return this.formatWeight(pound, includeUnits, floorIfMetric, this.useMetric(appVersion));
};

const lbfOrKn = function (pound, includeUnits, useMetric = false, precision  = 3, floorIfMetric = false) {
    let isMetric = false;
    if (useMetric) {
        if (typeof useMetric === 'boolean') {
            isMetric = useMetric;
        } else {
            isMetric = (parseInt(useMetric) != 0);
        }  
    }

    return this.formatForce(pound, includeUnits, isMetric, precision, floorIfMetric);
}

const lbPerFootOrKgPerM = function(lbPerFoot, includeUnits, appVersion = null) {
    let v = this.useMetric(appVersion) ? (lbPerFoot * kilogramPerPound / meterPerFoot).toFixed(2) : lbPerFoot;
    return includeUnits ? `${v} ${this.useMetric(appVersion) ? 'Kg/m.' : 'lb/ft.'}` : v;
};

const isUserDefined = function(param) {
    if (param && param != 'undefined') {
        return param.toUpperCase() == 'USER DEFINED';
    }
    return false;
};

const useMetric = function(appVersion = null) {
    try {
        if (2 == appVersion) {
            return this.$store.state.submittalSystem.design.useMetric == 1;
        } else {
            return this.$store.state.seismicSystem.design.useMetric == 1;
        }
    } catch (e) {
        console.error('store not accessible');
    }
    return false;
};

const lb2kg = function(pound) {
    return kilogramPerPound * pound;
}

const formatWeight = function(pound, includeUnits, floorIfMetric, isMetric) {
    let v = Number.parseFloat(pound);

    if (Number.isNaN(v)) {
        v = 0;
    }

    if (isMetric) {
        let kg = lb2kg(pound);
        v = (floorIfMetric ? Math.floor(kg) : kg.toFixed(2))
    } else {
        v = v.toFixed(2);
    }

    return includeUnits ? `${v} ${isMetric ? 'kg.' : 'lb.'}` : v;
}

const formatForce = function(pound, includeUnits, isMetric, precision, floorIfMetric) {
    if (!pound) {
        return '';
    }
    let v = pound;

    if (isMetric) {
        let kn = lb2kg(pound) * kgKnConversion;
        v = (floorIfMetric ? Math.floor(kn) : kn.toFixed(precision))
    }

    return includeUnits ? `${v} ${isMetric ? 'kN.' : 'lbf.'}` : v;
}

Vue.mixin({
    methods: {
        ftOrM,
        inOrCm,
        inOrMm,
        lbOrKg,
        lbfOrKn,
        lbPerFootOrKgPerM,
        npsOrDn,
        isUserDefined,
        useMetric,
        lb2kg,
        formatWeight,
        formatForce,
    },
});